import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { AddUserComponent } from '../add-user/add-user.component';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';
// import { componentNeedsResolution } from '@angular/core/src/metadata/resource loading';
import { UsersService } from '../../../shared/services/users.service';
import * as _ from "underscore";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentName, ModalSize } from 'src/app/Enum/usersFilterEnums';

@Component({
  selector: 'app-users-header',
  templateUrl: './users-header.component.html',
  styleUrls: ['./users-header.component.less']
})
export class UsersHeaderComponent implements OnInit ,OnDestroy{
  modalRef: BsModalRef;
  private unsubscribe$ =new Subject<void>();
  @ViewChild('userame') userename: ElementRef;
  @Input() tableSettings;
  @Output() searchByName = new EventEmitter();
  @Output() resetFilters = new EventEmitter();

  constructor(private modalService: BsModalService, private usersService: UsersService) {
  }

  ngOnInit() {

    this.usersService.resetHeaders
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.userename.nativeElement.value = '';
      this.usersService.refreshPage.next();
    })
  }

  addUser() {
    this.modalRef = this.modalService.show(AddUserComponent, { class: 'add-user-modal-xl' });
  }

  SearchByUser(username) {
    this.searchByName.emit(username);
  }

  ResetFilters() {

    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Reset Filter';
    this.modalRef.content.description = 'Do you want to reset all filters';
    this.modalRef.content.buttonsTitle = {
      dismiss: 'Cancel',
      confirm: 'Reset',
      component: ComponentName.Users
    }
  }

  hideDropdowns() {
    this.tableSettings.forEach(item =>{
      item.displaysort = false;
    })
    // _.each(this.tableSettings, function (item) {
    //   item.displaysort = false;
    // })
  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
